import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

/**
 * Download data as Excel file
 * @param {Array} data - Array of objects 
 * @param {Array} columns - Array of {header, key, width?}
 * @param {string} filename - File name without extension
 * @param {string} sheetName - Excel sheet name
 */
export const downloadExcel = (data, columns, filename, sheetName = 'Sheet1') => {
  const headers = columns.map(c => c.header);
  const rows = data.map(row => columns.map(c => {
    const val = c.format ? c.format(row[c.key], row) : row[c.key];
    return val ?? '-';
  }));
  
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  
  // Set column widths
  ws['!cols'] = columns.map(c => ({ wch: c.width || 15 }));
  
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

/**
 * Download data as PDF file
 * @param {Array} data - Array of objects
 * @param {Array} columns - Array of {header, key, width?}
 * @param {string} filename - File name without extension
 * @param {string} title - PDF title
 * @param {string} subtitle - Optional subtitle (e.g., filter info)
 */
export const downloadPDF = (data, columns, filename, title, subtitle = '') => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  
  // Title
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 14, 15);
  
  // Subtitle (filters info)
  if (subtitle) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100);
    doc.text(subtitle, 14, 22);
    doc.setTextColor(0);
  }
  
  // Date
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text(`Generated: ${new Date().toLocaleDateString('en-GB')} ${new Date().toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'})}`, 14, subtitle ? 27 : 22);
  
  // Table
  const tableHeaders = columns.map(c => c.header);
  const tableRows = data.map(row => columns.map(c => {
    const val = c.format ? c.format(row[c.key], row) : row[c.key];
    return val != null ? String(val) : '-';
  }));
  
  doc.autoTable({
    head: [tableHeaders],
    body: tableRows,
    startY: subtitle ? 30 : 25,
    styles: { fontSize: 7, cellPadding: 2 },
    headStyles: { fillColor: [41, 65, 122], textColor: 255, fontSize: 7, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 247, 250] },
    margin: { left: 14, right: 14 },
  });
  
  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(150);
    doc.text(`Page ${i} of ${pageCount} | Total Records: ${data.length}`, 14, doc.internal.pageSize.height - 8);
  }
  
  doc.save(`${filename}.pdf`);
};
